// @flow

/* eslint-disable ta-code-conventions/has-matching-storydoc, ta-code-conventions/has-matching-test */

import * as React from 'react';

/** FollowInteractionsPlacement are defined in the FollowCommonFields in the interactions microservice definitions */
export type FollowInteractionsPlacement =
  | 'FOLLOWERS_MODAL'
  | 'FOLLOWING_MODAL'
  | 'SUGGESTED_FOLLOWEES_RIGHT_RAIL'
  | 'FOLLOW_PROFILE_IN_VIEW'
  | 'SUGGESTED_FOLLOWEES_MODAL'
  | 'PROFILE_PERSISTENT_HEADER';

type FollowPlacementContext = {|
  placement: FollowInteractionsPlacement,
|};

/** null value if context does not exist */
// $FlowFixMe92
export default React.createContext((null: ?FollowPlacementContext));
